import { FormModal } from '~/shared/forms/FormModal';
import type { FormValues } from '~/shared/forms/types';
import { editCustomGoalOptions, GoalDefinitionTypeEnum, type EditCustomGoalCommand, type FullOrderViewModel } from '@generated';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { TextAreaFormField } from '~/shared/forms/controls/fields/text-fields/TextAreaFormField';
import Yup from '~/util/yup';
import { useGoalsAndnterventionsForOrder } from '../queries';
import { useSuspenseQuery } from '@tanstack/react-query';

const validationSchema = Yup.object().shape({
	subject: Yup.string().nullable().label('Subject').required(),
	definitionText: Yup.string().nullable().label('Definition Text').required()
});

export function EditCustomGoalFormModal({
	goalId,
	fullOrder,
	closeModal
}: {
	goalId: string;
	fullOrder: FullOrderViewModel;
	closeModal: () => void;
}) {
	const goal = fullOrder.goals.find(goal => goal.id === goalId);
	if (!goal) {
		throw new Error('Goal not found');
	} else if (goal.goalDefinitionTypeId !== GoalDefinitionTypeEnum.Custom) {
		throw new Error('Goal is not a custom goal');
	}
	const { refetch } = useSuspenseQuery(useGoalsAndnterventionsForOrder(fullOrder.id));

	const onSaveTransform = (values: FormValues): EditCustomGoalCommand => {
		return {
			orderId: fullOrder.id,
			goalId: goal.id,
			subject: values.subject,
			definitionText: values.definitionText
		};
	};

	return (
		<FormModal
			title="Edit Goal"
			closeModal={closeModal}
			initialValues={{
				subject: goal.customGoalSubject,
				definitionText: goal.customGoalDefinitionText
			}}
			saveMutation={editCustomGoalOptions}
			onSuccess={() => {
				refetch();
				closeModal();
			}}
			onSaveTransform={onSaveTransform}
			validationSchema={validationSchema}
			size="lg"
		>
			<div className="w-full max-w-3xl space-y-4">
				<TextFormField name="subject" />
				<TextAreaFormField name="definitionText" />
			</div>
		</FormModal>
	);
}
